import React from 'react';
import { Field, Select } from '../ui';
import { useRemote } from '../api';

export const ProductIdentityFields = ({ bind }) => {
  const categories = useRemote('/categories');
  return <>
    <h2>Product identity</h2>
    <div className="form-grid">
      <Field id="product-form-name" label="Product name" required minLength={3} {...bind('name')} />
      <Field id="product-form-sku" label="Unique SKU" pattern={'[A-Za-z0-9_\\-]{3,40}'} required {...bind('sku')} />
      <Select id="product-form-category" label="Category" {...bind('category')}>
        {categories.data?.map(category => <option key={category.id} value={category.id}>{category.name}</option>)}
      </Select>
      <Select id="product-form-industry" label="Industry" {...bind('industry')}>
        {['Manufacturing', 'Construction', 'Logistics', 'Textiles', 'Pharma'].map(value => <option key={value}>{value}</option>)}
      </Select>
    </div>
    <Field id="product-form-description" label="Description" area required minLength={10} {...bind('description')} />
    <Field id="product-form-image" label="Product image URL (HTTPS, optional)" type="url" placeholder="https://…" {...bind('image_url')} />
  </>;
};

export const ProductSupplyFields = ({ bind, specText, setSpecText }) => <>
  <h2>Technical & supply details</h2>
  <div className="form-grid">
    <Field id="product-form-grade" label="Grade / material" required {...bind('grade')} />
    <Field id="product-form-standard" label="Reference standard" {...bind('standard')} />
    <Field id="product-form-hsn" label="HSN / SAC code" pattern="[0-9]{4,8}" required {...bind('hsn')} />
    <Field id="product-form-packaging" label="Packing unit" required {...bind('packaging')} />
    <Field id="product-form-unit" label="Selling unit" required {...bind('unit')} />
    <Field id="product-form-moq" label="Minimum order quantity" type="number" min="1" required {...bind('moq')} />
    <Field id="product-form-stock" label="Available stock" type="number" min="0" required {...bind('stock')} />
    <Field id="product-form-lead" label="Lead time (days)" type="number" min="1" max="365" required {...bind('lead_days')} />
  </div>
  <Field id="product-form-specs" label="Specifications (one attribute: value per line)" area
    placeholder={'Material: Stainless steel\nDiameter: 25 mm'} value={specText} onChange={event => setSpecText(event.target.value)} />
</>;

export const ProductPricingFields = ({ bind, tiers, updateTier }) => <>
  <h2>Wholesale pricing</h2>
  <Select id="product-form-gst" label="GST rate (merchant must verify classification)" {...bind('gst_percent')}>
    {[0, 5, 12, 18, 28].map(value => <option key={value} value={value}>{`${value}%`}</option>)}
  </Select>
  <div className="pricing-editor">{tiers.map((tier, index) => <div key={tier.editorId}>
    <span>Tier {index + 1}</span>
    <Field id={`tier-min-${index}`} label="From quantity" type="number" min="1" required value={tier.min_qty}
      onChange={event => updateTier(tier.editorId, 'min_qty', Number(event.target.value))} />
    <Field id={`tier-price-${index}`} label="Unit price (₹ excl. GST)" type="number" min="0.01" step="0.01" required value={tier.price}
      onChange={event => updateTier(tier.editorId, 'price', Number(event.target.value))} />
  </div>)}</div>
  <p className="form-note">First tier must match MOQ. Volume prices must not increase.</p>
</>;